export const baseFontSize = 16;

type TypographyLevel = 'body' | 'heading';

interface FontFamilyDefinition {
  name: string;
  src: { weight: number; sources: { format: string; url: string }[] }[];
}

export const family: Record<TypographyLevel, FontFamilyDefinition> = {
  body: {
    name: "'DM Sans'",
    src: [
      {
        weight: 400,
        sources: [
          {
            format: 'woff2',
            url: 'https://static.otta.com/fonts/dm-sans-regular.woff2',
          },
          {
            format: 'woff',
            url: 'https://static.otta.com/fonts/dm-sans-regular.woff',
          },
          {
            format: 'truetype',
            url: 'https://static.otta.com/fonts/dm-sans-regular.ttf',
          },
        ],
      },
      {
        weight: 700,
        sources: [
          {
            format: 'woff2',
            url: 'https://static.otta.com/fonts/dm-sans-bold.woff2',
          },
          {
            format: 'woff',
            url: 'https://static.otta.com/fonts/dm-sans-bold.woff',
          },
          {
            format: 'truetype',
            url: 'https://static.otta.com/fonts/dm-sans-bold.ttf',
          },
        ],
      },
    ],
  },
  heading: {
    name: "'Fann Grotesque'",
    src: [
      {
        weight: 400,
        sources: [
          {
            format: 'woff2',
            url: 'https://static.otta.com/fonts/FannGrotesque-Medium.woff2',
          },
          {
            format: 'woff',
            url: 'https://static.otta.com/fonts/FannGrotesque-Medium.woff',
          },
          {
            format: 'truetype',
            url: 'https://static.otta.com/fonts/FannGrotesque-Medium.ttf',
          },
        ],
      },
      {
        weight: 700,
        sources: [
          {
            format: 'woff2',
            url: 'https://static.otta.com/fonts/FannGrotesque-Bold.woff2',
          },
          {
            format: 'woff',
            url: 'https://static.otta.com/fonts/FannGrotesque-Bold.woff',
          },
          {
            format: 'truetype',
            url: 'https://static.otta.com/fonts/FannGrotesque-Bold.ttf',
          },
        ],
      },
      {
        weight: 900,
        sources: [
          {
            format: 'woff2',
            url: 'https://static.otta.com/fonts/FannGrotesque-Black.woff2',
          },
          {
            format: 'woff',
            url: 'https://static.otta.com/fonts/FannGrotesque-Black.woff',
          },
          {
            format: 'truetype',
            url: 'https://static.otta.com/fonts/FannGrotesque-Black.ttf',
          },
        ],
      },
    ],
  },
};
